import { render, staticRenderFns } from "./pintcs.vue?vue&type=template&id=288899c2&scoped=true&"
import script from "./pintcs.vue?vue&type=script&lang=js&"
export * from "./pintcs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288899c2",
  null
  
)

export default component.exports